module.exports = __webpack_public_path__ + "static/media/maskot-head.f04c1f20.png";